import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowRight, Users } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { useTranslation } from '../data/translations';

export const TeamTeaser = () => {
  const { language } = useLanguage();
  const t = useTranslation(language);
  return (
    <section className="py-20 md:py-28 bg-white" data-testid="team-teaser-section">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <motion.div initial={{ opacity: 0, x: -30 }} whileInView={{ opacity: 1, x: 0 }} viewport={{ once: true }} className="relative">
            <div className="relative overflow-hidden">
              <img src="https://customer-assets.emergentagent.com/job_a13cc131-3351-41ce-87d0-56be3a0fcef6/artifacts/dbt3hpvl_PHOTO-2026-04-10-17-17-48.jpg" alt="BENI Gipsergeschäft Firmenfahrzeuge" className="w-full h-auto" />
              <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent p-6">
                <div className="text-white font-heading font-bold text-lg">Beni Gipsergeschäft GmbH</div>
                <div className="text-white/70 text-sm">Unternehmen seit 2019</div>
              </div>
            </div>
          </motion.div>
          <motion.div initial={{ opacity: 0, x: 30 }} whileInView={{ opacity: 1, x: 0 }} viewport={{ once: true }} transition={{ delay: 0.2 }}>
            <h2 className="font-heading text-3xl md:text-4xl font-bold text-[#1A1A1A] mb-6" data-testid="team-teaser-title">{t.team.about_title}</h2>
            <div className="space-y-4 text-gray-600 leading-relaxed mb-8">
              <p>{t.team.about_text}</p>
              <p>{t.team.values}</p>
              <p className="text-[#E31C23] font-medium">{t.team.apprentice}</p>
            </div>
            <div className="flex flex-col sm:flex-row gap-4">
              <Link to="/team" className="inline-flex items-center justify-center space-x-2 bg-[#E31C23] text-white px-8 py-4 font-semibold hover:bg-[#B91219] transition-colors" data-testid="team-cta"><span>{t.hero.view_reviews}</span><ArrowRight className="w-5 h-5" /></Link>
              <Link to="/kontakt" className="inline-flex items-center justify-center space-x-2 border-2 border-[#1A1A1A] text-[#1A1A1A] px-8 py-4 font-semibold hover:bg-[#1A1A1A] hover:text-white transition-colors" data-testid="contact-cta"><span>{t.nav.contact}</span></Link>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};
